/**
 * # Intl.DateTimeFormat
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
 *
 * ## full options:
 * https://devhints.io/wip/intl-datetime
 *
 *  weekday: 'narrow' | 'short' | 'long',
 *  era: 'narrow' | 'short' | 'long',
 *  year: 'numeric' | '2-digit',
 *  month: 'numeric' | '2-digit' | 'narrow' | 'short' | 'long',
 *  day: 'numeric' | '2-digit',
 *  hour: 'numeric' | '2-digit',
 *  minute: 'numeric' | '2-digit',
 *  second: 'numeric' | '2-digit',
 *  timeZoneName: 'short' | 'long',
 *  timeZone: 'Asia/Shanghai',
 *  hour12: true | false,
 *  hourCycle: 'h11' | 'h12' | 'h23' | 'h24',
 *  formatMatcher: 'basic' | 'best fit'
 *  dateStyle:
 *    'full'   // "es": "miércoles, 18 de agosto de 2021"              "en": "Wednesday, August 18, 2021"
 *    'long'   // "es": "18 de agosto de 2021"                         "en": "August 18, 2021"
 *    'medium' // "es": "18 ago 2021"                                  "en": "Aug 18, 2021"
 *    'short'  // "es": "18/8/21"                                      "en": "8/18/21"
 *  timeStyle:
 *    'full'   // "es": "18:45:32 (hora de verano de Europa central)"  "en": "6:46:50 PM Central European Summer Time"
 *    'long'   // "es": "18:45:19 CEST"                                "en": "6:46:56 PM GMT+2"
 *    'medium' // "es": "18:45:08"                                     "en": "6:47:01 PM"
 *    'short'  // "es": "18:44"                                        "en": "6:47 PM"
 *
 * ## dateStyle y timeStyle proposal
 * https://github.com/tc39/proposal-intl-datetime-style/blob/master/README.md
 */

export const DATEFORMATS_HUMANIZED = {
  datetime: { dateStyle: 'full', timeStyle: 'short' },
  datetimelong: { dateStyle: 'full', timeStyle: 'medium' },
  date: { dateStyle: 'full' },
  time: { timeStyle: 'short' },
  timelong: { timeStyle: 'medium' },
};
